export default {
  ALROSA: 'alrosa',
  BAT_PERSONAL_ACCOUNT: 'bat-personal-account',
  BAT_CHAMPIONSHIP: 'bat-championship',
  BCG_TEST: 'bcg-test',
  BK_MANAGER: 'bk-manager',
  CITIBANK: 'citibank',
  CITIBANK_RYAZAN: 'citibank-ryazan',
  CITIBANK_AMBASSADOR: 'citibank-ambassador',
  DANONE: 'danone',
  DELOITTE_SF: 'deloitte-sf',
  FENICHE: 'feniche',
  JAPAN_517: 'japan-517',
  JTI_INNER: 'innerjti',
  JTI_MAKE_IT_BRIGHT_STAGE_ONE: 'jti-make-it-bright-stage-one',
  JTI_MAKE_IT_BRIGHT_STAGE_TWO: 'jti-make-it-bright-stage-two',
  JTI_MAKE_IT_BRIGHT_STAGE_THREE: 'jti-make-it-bright-stage-three',
  JTI_MIB: 'JtiMibChallenge',
  JTI_MIB_PIXELS: 'JtiMibPixels',
  KPMG: 'kpmg', // Kept
  MARS: 'mars',
  MARS_AB: 'mars-ab',
  MARS_MIEP: 'mars-miep',
  MARS_MLEP: 'mars-mlep',
  METRO: 'metro',
  NMG: 'nmg',
  OBI: 'obi',
  PWC: 'pwc',
  QMARKETING: 'qmarketing',
  QUESTIONNAIRE_LANDING: 'questionnaire-landing',
  SBERBANK: 'sberbank',
  SCHLUMBERGER_CAREER: 'schlum-career',
  SCHLUMBERGER: 'schlum',
  SIBUR_TEST: 'sibur-test',
  SIBUR_INTERNSHIPS: 'sibur-stajirovki',
  SKOLKOVO: 'skolkovo',
  SPORTMASTER: 'sportmaster',
  UNILEVER: 'unilever',
  X5: 'x5'
};
